import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { CalendarEventDateString } from 'components/calendar';
import { ProductLinkWithIcon } from 'components/common';
import { Box, BoxRow } from 'components/common/box';

import type { GetLinkedCalendarEventsInAchievementRes } from 'shared-types/responses';

const AchievementUsersLinkedCalendarEvents = () => {
  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const { data, loading } = useApiData<GetLinkedCalendarEventsInAchievementRes>(
    {
      url: `/admin/achievements/${achievement.id}/calendar-events`,
      onlyIf: Boolean(achievement.id)
    }
  );

  if (!achievement) return null;

  return data?.calendarEvents?.length ? (
    <Box
      loading={loading}
      padding={0}
      title={messages.achievementLinkedCalendarEvents}
      titleTooltip={messages.achievementLinkedCalendarEventsInfo}
      style={{ marginTop: 50 }}
    >
      {data.calendarEvents.map((event) => (
        <BoxRow key={event.id}>
          <ProductLinkWithIcon
            calendarEvent={event}
            disableLink={!event.isOwnerOrSuperadmin}
            titleStyle={{ fontWeight: 600 }}
          >
            <CalendarEventDateString
              startDate={event.startDate as string}
              endDate={event.endDate as string}
            />
          </ProductLinkWithIcon>
        </BoxRow>
      ))}
    </Box>
  ) : null;
};

export default AchievementUsersLinkedCalendarEvents;
